import React, { useState, useEffect } from 'react';
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { BookmarkCheck, X, Search } from 'lucide-react';
import { toast } from 'sonner';

const STORAGE_KEY = 'clinivo_saved_searches';

export function useSavedSearches() {
  const [savedSearches, setSavedSearches] = useState([]);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      setSavedSearches(stored);
    } catch {
      setSavedSearches([]);
    }
  }, []);

  const saveSearch = (filters) => {
    const label = [
      filters.searchTerm,
      filters.specialty,
      filters.location,
      filters.jobType
    ].filter(Boolean).join(' · ') || 'All Jobs';

    const search = { label, filters, savedAt: Date.now() };
    const updated = [search, ...savedSearches.filter(s => s.label !== label)].slice(0, 5);
    setSavedSearches(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    toast.success('Search saved!');
  };

  const removeSearch = (label) => {
    const updated = savedSearches.filter(s => s.label !== label);
    setSavedSearches(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  return { savedSearches, saveSearch, removeSearch };
}

export default function SavedSearches({ savedSearches, onApply, onRemove }) {
  if (!savedSearches || savedSearches.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-slate-500 flex items-center gap-1">
        <BookmarkCheck className="h-3.5 w-3.5" />
        Saved:
      </span>
      {savedSearches.map((search) => (
        <div key={search.label} className="flex items-center gap-0.5">
          <button
            onClick={() => onApply(search.filters)}
            className="text-xs bg-teal-50 hover:bg-teal-100 text-teal-700 border border-teal-200 rounded-l-full px-2.5 py-1 transition-colors flex items-center gap-1"
          >
            <Search className="h-3 w-3" />
            {search.label}
          </button>
          <button
            onClick={() => onRemove(search.label)}
            className="text-xs bg-teal-50 hover:bg-red-50 text-teal-500 hover:text-red-500 border border-teal-200 border-l-0 rounded-r-full px-1.5 py-1 transition-colors"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ))}
    </div>
  );
}